module.exports = __webpack_public_path__ + "img/58.6bec9830.jpg";